import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalendarPercent = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.984 9.664h16.041M15.64 3v2.962M8.37 3v2.962"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.815 4.422h-7.62C5.55 4.422 3.9 5.894 3.9 8.599v8.146C3.9 19.494 5.55 21 8.194 21h7.613c2.651 0 4.293-1.48 4.293-4.187V8.6c.008-2.705-1.634-4.177-4.286-4.177"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.778 17.379 4.547-4.547M14.213 17.307v.045m.181-.035a.182.182 0 1 1-.364 0 .182.182 0 0 1 .364 0M9.79 12.883v.045m.18-.035a.182.182 0 1 1-.364 0 .182.182 0 0 1 .365 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCalendarPercent);
export default ForwardRef;
